module.exports = __webpack_public_path__ + "static/media/encyclopedia.cf89fdd4.PNG";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/books/encyclopedia.PNG
// module id = 1794
// module chunks = 1